import styled from "styled-components";

const Container = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.3px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const Bi = () => {
  return <Container>FollowingMoments</Container>;
};

export default Bi;
